module.exports = __webpack_public_path__ + "img/attack_aqua.dbe49177.png";